import axios from 'axios'
import iView from "view-design";
import router from '../router';
import {regionData} from "./regionData";
import {store} from "../main";
import moment from "moment";

/**
 * 获取本地化支付状态
 * @param payment
 * @returns {string}
 */
export const getPaymentStatus = (payment) => {
  let lang = getLocalLang();
  switch (payment) {
    case 1:
      if (lang === 'en') {
        return 'Unpaid';
      } else {
        return '待支付';
      }
    case 2:
      if (lang === 'en') {
        return 'Paid';
      } else {
        return '已支付';
      }
    case 3:
      if (lang === 'en') {
        return 'Refunded';
      } else {
        return '已退款';
      }
    case 4:
      if (lang === 'en') {
        return 'Cancelled';
      } else {
        return '已取消';
      }
  }
};

/**
 * 货币常量：新西兰元
 * @type {number}
 */
export const NZ_DOLLAR = 1;
/**
 * 货币常量：人民币
 * @type {number}
 */
export const RMB = 2;

/**
 * 返回缓存中本地语言
 * @returns {string}
 */
export const getLocalLang = () => {
  let lang = navigator.language;
  if (empty(localStorage.getItem('lang'))) {
    if (lang.indexOf('zh') !== -1) {
      localStorage.setItem('lang', 'zh');
      return 'zh';
    } else {
      localStorage.setItem('lang', 'en');
      return 'en';
    }
  } else {
    return localStorage.getItem('lang');
  }
}

/**
 * 根据缓存中的本地语言获取对应货币
 * @returns {number}
 */
export const getLocalCurrency = () => {
  let lang = getLocalLang();
  if (lang === 'zh') {
    return RMB;
  } else {
    return NZ_DOLLAR;
  }
}

/**
 * 根据缓存中的本地语言获取对应货币符号
 * @param currencyType 货币类型，如果传入就以此返回货币符号
 * @returns {string}
 */
export const getLocalCurrencySymbol = (currencyType) => {
  if (empty(currencyType)) {
    let lang = getLocalLang();
    if (lang === 'zh') {
      return '￥';
    } else {
      return 'NZ$';
    }
  } else {
    if (currencyType === NZ_DOLLAR) {
      return 'NZ$';
    } else {
      return '￥';
    }
  }

}

/**
 /**
 * 判断对象是否为空
 * @param obj
 * @returns {boolean}
 */
export const empty = (obj) => {
  if (obj === '' || obj === null || obj === undefined || JSON.stringify(obj) === '{}' || obj.length === 0) {
    return true;
  }
  return false;
}

/**
 * 邮箱格式校验
 * @param email
 * @returns {boolean}
 */
export let emailValidate = (email='') => {
  let reg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})(\.[a-zA-Z]{2,4})*$/;
  return reg.test(email);
};

/**
 * 字符串是否英文校验
 * @param name
 * @returns {boolean}
 */
export const isEnglishNameValidate = (name) => {
  const reg = /^[\w\s]+$/;
  return reg.test(name);
};

/**
 * 网络请求方法
 * @param url 接口地址
 * @param method 请求方法：GET POST
 * @param data 请求数据
 * @param isShowMask 是否显示网络请求时的遮罩
 * @param isShowReturnMsg 是否在前端显示请求失败时的通知提示
 * @param handler 请求返回400时的后续处理方法
 */
export const urlRequest = ({url = '', method = 'GET', data = {}, isShowMask = true, isShowReturnMsg = true, handler = () => {}}) => {
  // 请求参数加入本地语言类型
  data.lang = getLocalLang();
  return new Promise((resolve, reject) => {
    if (isShowMask) {
      // 请求接口时显示加载等待
      iView.Spin.show();
    }
    
    axios({
      url: url,
      method: method,
      headers: {
        "Authorization":  localStorage.getItem('token')
      },
      data: data,
    }).then((res) => {
      if (parseInt(res.data.code) === 200) {
        console.log('请求成功, 接口地址：' + url + ', 请求结果：', res);
        resolve(res);
      } else if (parseInt(res.data.code) === 401 && res.data.msg === '登录已失效，请重新登录') {
        console.log('token过期，请重新登录');
        // 清除缓存的token
        localStorage.removeItem('token');
      } else if (parseInt(res.data.code) === 400) {
        if (isShowReturnMsg) {
          iView.Message.warning({content: res.data.msg, duration: 3});
        } else {
          console.log('Network request error 400: ', res.data.msg);
        }
        // 后续处理方法
        handler();
      } else {
        iView.Message.error({content: res.data.msg? res.data.msg : 'Network error, try again later.', duration: 5});
      }
    }).catch((e) => {
      console.log('请求失败：', e);
      iView.Message.error({content: 'Network error, try again later.', duration: 5});
      reject(e);
    }).finally(() => {
      // 请求完成后都要去掉加载等待
      iView.Spin.hide();
    });
  });
};

/**
 * 页面跳转方法
 * @param route 要跳转的路由
 * @param params 传入参数
 */
export const gotoPage = ({path='', params={}}) => {
  router.push({path: path, query: params}).catch(e => console.log(e));
};

/**
 * 返回上一页，如果没有，就回到首页
 */
export const goBack = () => {
  window.history.length > 1 ? router.go(-1) : router.push('/');
};

/**
 * 获取国家地区数据
 * @returns {[]}
 */
export const getRegions = () => {
  // 根据缓存的本地语言信息展示
  let lang = getLocalLang();
  return  regionData.map(item => {
    if (lang === 'en') {
      return item.data.enName;
    } else {
      return item.data.cnName;
    }
  });
};


/**
 * 获取国家地区文本
 * @param regionIndex
 * @param lang
 * @returns {string}
 */
export const getMultiLangRegion = (regionIndex, lang) => {
  if (lang === 'en') {
    return regionData[regionIndex].data.enName;
  } else {
    return regionData[regionIndex].data.cnName;
  }
};

/**
 * 获取国家地区电话代码
 * @returns {[]}
 */
export const getRegionCodes = () => {
  // 根据缓存的本地语言信息展示
  let lang = getLocalLang();
  return regionData.map(item => {
    let enVal = item.data.enName + ' ' + item.data.code;
    let cnVal = item.data.cnName + ' ' + item.data.code;
    let enLabel = item.data.code;
    let cnLabel = item.data.code;
    if (lang === 'en') {
      return {label: enLabel, value: enVal};
    } else {
      return {label: cnLabel, value: cnVal};
    }
  });
};

/**
 * 获取登录状态
 * @returns {boolean}
 */
export let getLoginStatus = () => {
  // return !empty(localStorage.getItem('token'));
  return store.state.isLogin;
};


/**
 * 退出登录
 */
export const logout = () => {
  // 保存缓存中本地语言
  let lang = getLocalLang();
  // 清除缓存中的token和userInfo等信息
  localStorage.clear();
  // 重新写入本地语言进入缓存
  localStorage.setItem('lang', lang);
  // 将入住和离店日期初始化为当天
  localStorage.setItem('checkinDate', moment().format('YYYY-MM-DD'));
  localStorage.setItem('checkoutDate', moment().add(1, 'd').format('YYYY-MM-DD'));

  store.commit('setLoginStatus', false);
  store.commit('setUserInfo', {});
  store.commit('delOrderList');
  // 退出后页面重新定向到首页
  router.replace({path: '/'}).catch(e => console.log(e));
};

